export const User = [
    {
        id : 1,
        Name : 'User',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },
    {
        id : 2,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 3,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 4,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },

]

export const Vendor = [
    {
        id : 1,
        Name : 'Vendor',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 2,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 3,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 4,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },

]

export const Admin = [
    {
        id : 1,
        Name : 'Admin',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 2,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 3,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 4,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },

]

export const SuperAdminData = [
    {
        id : 1,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 2,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 3,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },{
        id : 4,
        Name : 'John',
        Mail : 'John@example.com',
        Phone : '123-456',
        Status : 'Atcive',
        Active : "Edit | Delete"
    },

]